(function () {
  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
    );

  angular.module('MktzapApp.Controllers')
    .controller('ReportsSessionControlController', reports);

  reports.$inject = ['$scope', '$http', '$timeout', 'ngTableParams', 'NotificationService', 'CompanyService', '$rootScope', 'UserService'];

  function reports ($scope, $http, $timeout, ngTableParams, NotificationService, CompanyService, $rootScope, UserService) {
    var vm = this;
    $scope.vm = vm;

    vm.loading = false;
    vm.profile_type = null;

    vm.profiles = [{ name: 'Todos', role: null }, { name: 'Gestor', role: 1 }, { name: 'Operador', role: 0 }]
    if ($rootScope.checkMenuAccess('lord')) {
      vm.profiles = [{ name: 'Todos', role: null }, { name: 'Lord', role: 1000 }, { name: 'Gestor', role: 1 }, { name: 'Operador', role: 0 }]
    }

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      operator_id: '1'
    };

    vm.filters.profile_type = null;
    vm.filters.operator_id = '0';
    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };
    vm.validProfileType = function () {
      if (vm.filters == undefined) {
        vm.filters = {};
        vm.filters.profile_type = null;
      }
      vm.filters.operator_id = '0';
    }

    vm.getAllUsersByRole = function () {
      vm.usersCopy = [];
      UserService.searchUserByRole()
        .$promise
        .then(function (data) {
          data.forEach(function (user) {
            if (user.inactive_since != null) {
              user.name = user.name + ' (Inativo)'
            }
          })
          vm.users = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao carregar usuários.')
        })
    }
    vm.getAllUsersByRole();

    vm.sendReportByEmail = function (isSearch) {
      CompanyService
        .loadMetadata()
        .$promise
        .then(function (data) {
          $http.get(apiUrl + '/reports/session-control', {
            params: {
              filters: vm.filters
            }
          })

          NotificationService.successHandler(data, 'O relatório de Controle de Sessão será enviado em seu email.');
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Algo deu errado ao carregar metadados.');
        });
    };
  }
})();
